import {createSlice} from "@reduxjs/toolkit";

const initialCompanyProductsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  categories: null,
  brands: null,
  plans: null,
  language: null,
  companyProductForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const companyProductsSlice = createSlice({
  name: "companyProducts",
  initialState: initialCompanyProductsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // companyProductFetched
    companyProductFetched: (state, action) => {
      state.actionsLoading = false;
      state.companyProductForEdit = action.payload.companyProductForEdit;
      state.error = null;
    },
    // companyProductsFetched
    companyProductsFetched: (state, action) => {
      const { totalCount, entities, categories, brands, plans, language } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.categories = categories;
      state.brands = brands;
      state.plans = plans;
      state.language = language;
      state.totalCount = totalCount;
    },
    // companyProductCreated
    companyProductCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.product);
    },
    // companyProductUpdated
    companyProductUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.product.id) {
          return action.payload.product;
        }
        return entity;
      });
    },
    // companyProductDeleted
    companyProductDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // companyProductsDeleted
    companyProductsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // companyProductsUpdateState
    companyProductsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
    // companyProductImagesUpdated
    companyProductImagesUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.companyProductForEdit.image = action.payload.images;
    }
  }
});
